import { cva } from "class-variance-authority";

// Board colours: success #2E7D32 on #E8F5E9 (dot #4CAF50), warning #B45309 on #FFF3DF (dot #E9A23B),
// danger #9A1C12 on #FBE3E0 (dot #E53935), neutral #4A564A on #EEF0EE (dot #9AA29A), info #1E4E8C on #E3EEFB,
// primary white on #4CAF50 (a granted write permission on the Rechten tab).
export const statusChipCva = cva("inline-flex w-fit shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full font-medium", {
  variants: {
    tone: {
      success: "bg-green-50 text-green-800 dark:bg-green-500/15 dark:text-green-300",
      warning: "bg-orange-50 text-warning-800 dark:bg-orange-500/15 dark:text-orange-300",
      danger: "bg-red-50 text-red-900 dark:bg-red-500/15 dark:text-red-300",
      neutral: "bg-gray-200 text-gray-750 dark:bg-dark-700 dark:text-gray-300",
      info: "bg-blue-50 text-blue-800 dark:bg-blue-500/15 dark:text-blue-300",
      primary: "bg-primary-500 text-white dark:bg-primary-600",
    },
    size: {
      sm: "px-2.5 py-1 text-xs leading-4",
      md: "px-2.5 py-1 text-[13px] leading-4",
    },
  },
  defaultVariants: {
    tone: "neutral",
    size: "sm",
  },
});

export const statusChipDotCva = cva("size-[7px] shrink-0 rounded-full", {
  variants: {
    tone: {
      success: "bg-green-500",
      warning: "bg-orange-400",
      danger: "bg-red-600",
      neutral: "bg-gray-500",
      info: "bg-blue-600",
      primary: "bg-white",
    },
    pulse: {
      true: "status-chip-dot--pulse",
      false: null,
    },
  },
  defaultVariants: {
    tone: "neutral",
    pulse: false,
  },
});

/**
 * Row tint of a table row whose status needs attention (Installed overview, age groups): warning rows on #FFFCF5,
 * danger rows on #FFF8F7. Success and neutral rows keep the table background.
 */
export const statusRowTintCva = cva("", {
  variants: {
    tone: {
      success: null,
      neutral: null,
      info: null,
      primary: null,
      warning: "bg-orange-50/40 dark:bg-orange-500/5",
      danger: "bg-red-50/50 dark:bg-red-500/5",
    },
  },
  defaultVariants: {
    tone: "neutral",
  },
});
